import {GrossScoreRow, HoleScore, HoleScoreType} from "../model/participant-card-model";
import {arrayOrEmpty} from "../../../common/extensions/array";
import {ScorecardRow} from "./row";

export function getGrossScoreRow(row: GrossScoreRow): ScorecardRow {
    let value = (score: HoleScore): string => {
        if (!score) {
            return ""
        }
        let classes = getClasses(score, score.par)

        return `<div class='${classes}'>${score.total ?? ""}</div> ${getHandicap(score.handicap)}`
    }
    return {
        name: "Score",
        outValues: row.data.outValues.map(score => value(score)),
        outTotal: row.data.outTotal,
        inValues: arrayOrEmpty(row.data.inValues).map(score => value(score)),
        inTotal: row.data.inTotal,
        total: row.data.total,
        classes: "score",
    };
}

function getClasses(score: HoleScore, par: number): string {
    if (score.type == HoleScoreType.PickUp) {
        return "ball-pickup"
    }
    if (!score.total) {
        return '';
    }
    const diff = score.total - par;
    if (diff > 1) {
        return "cell-square-solid";
    }
    if (diff === 1) {
        return "cell-square";
    }
    if (diff === 0) {
        return "";
    }
    if (diff === -1) {
        return "cell-circle";
    }
    return "cell-circle-solid";
}

function getHandicap(handicap: number): string {
    if (!handicap) {
        return "";
    }
    if (handicap <= -10 || handicap >= 10) {
        return "";
    }
    let html = `<div class="handicap ${(handicap > 0 ? "" : "negative")}">`;
    for (let i = 0; i < Math.abs(handicap); ++i) {
        html += "<div></div>";
    }
    return html + "</div>";
}

